import { ApiError } from '@iris/shared';
import { QueryClient } from '@tanstack/react-query';

/** TanStack Query defaults (T4 §2.2): errors the server answered are never retried; network errors twice. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (failures, error) => !(error instanceof ApiError) && failures < 2,
      refetchOnWindowFocus: true,
    },
    mutations: { retry: false },
  },
});
